interface BottomActionBarProps {
  ctaLabel: string;
  ctaTo?: string;
  onCtaClick?: () => void;
  className?: string;
}

export default function BottomActionBar({
  ctaLabel,
  ctaTo,
  onCtaClick,
  className = '',
}: BottomActionBarProps) {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E1DBD4] px-5 py-3 ${className}`}
    >
      {onCtaClick ? (
        <button
          onClick={onCtaClick}
          className="w-full h-12 flex items-center justify-center rounded-full bg-[#B4563F] text-white text-[15px] font-medium hover:bg-[#9F4633] active:bg-[#8C3E2D] transition-colors cursor-pointer whitespace-nowrap"
        >
          {ctaLabel}
        </button>
      ) : ctaTo ? (
        <a
          href={ctaTo}
          className="w-full h-12 flex items-center justify-center rounded-full bg-[#B4563F] text-white text-[15px] font-medium hover:bg-[#9F4633] active:bg-[#8C3E2D] transition-colors cursor-pointer whitespace-nowrap"
        >
          {ctaLabel}
        </a>
      ) : (
        <button
          disabled
          className="w-full h-12 flex items-center justify-center rounded-full bg-[#D1CCC5] text-white text-[15px] font-medium cursor-not-allowed whitespace-nowrap"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}